function sha256(buffer) {
  return crypto.subtle.digest('SHA-256', buffer);
}

export default sha256;
